import { Link } from 'react-router-dom';

export function PrivacyKo() {
  return (
    <div
      className="min-h-screen h-screen overflow-y-auto"
      style={{ backgroundColor: 'var(--color-bg-primary)' }}
    >
      <div className="max-w-3xl mx-auto px-6 py-12">
        {/* Header */}
        <div className="mb-8 flex justify-between items-center">
          <Link
            to="/"
            className="text-sm hover:underline"
            style={{ color: 'var(--color-text-secondary)' }}
          >
            &larr; 홈으로
          </Link>
          <Link
            to="/privacy"
            className="text-sm hover:underline"
            style={{ color: 'var(--color-text-secondary)' }}
          >
            English
          </Link>
        </div>

        <h1
          className="text-3xl font-bold mb-2"
          style={{ color: 'var(--color-text-primary)' }}
        >
          개인정보 처리방침
        </h1>
        <p
          className="text-sm mb-8"
          style={{ color: 'var(--color-text-secondary)' }}
        >
          시행일: 2025년 12월 7일
        </p>

        <div
          className="space-y-8 text-sm leading-relaxed"
          style={{ color: 'var(--color-text-secondary)' }}
        >
          {/* 제1조 총칙 */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              제1조 (총칙)
            </h2>
            <p>
              베이스랩스 주식회사(이하 &quot;회사&quot;)는 「개인정보 보호법」 제30조에 따라
              정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수
              있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.
            </p>
            <p className="mt-3">
              본 방침은 회사가 운영하는 사이클링 텔레메트리 시각화 서비스
              &quot;Pelo1&quot;(pelo.one)에 적용됩니다.
            </p>
          </section>

          {/* 제2조 개인정보 수집 항목 */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              제2조 (개인정보의 수집 항목)
            </h2>
            <p className="mb-3">회사는 서비스 제공을 위해 다음의 개인정보를 수집합니다.</p>

            <h3
              className="text-base font-medium mb-2 mt-4"
              style={{ color: 'var(--color-text-primary)' }}
            >
              1. 회원가입 시 수집 항목
            </h3>
            <ul className="list-disc list-inside space-y-1">
              <li><strong>필수항목:</strong> 이메일 주소, 비밀번호, 닉네임</li>
              <li><strong>소셜 로그인 시:</strong> 이메일 주소, 프로필 이미지 (Google 제공 정보)</li>
            </ul>

            <h3
              className="text-base font-medium mb-2 mt-4"
              style={{ color: 'var(--color-text-primary)' }}
            >
              2. 서비스 이용 시 수집 항목
            </h3>
            <ul className="list-disc list-inside space-y-1">
              <li><strong>활동 데이터:</strong> GPS 위치정보, 속도, 심박수, 파워(와트), 케이던스, 고도, 이동거리, 경과시간</li>
              <li><strong>기기 정보:</strong> Garmin 기기 배터리 잔량</li>
              <li><strong>파일 데이터:</strong> FIT 파일, GPX 파일에 포함된 활동 기록</li>
            </ul>

            <h3
              className="text-base font-medium mb-2 mt-4"
              style={{ color: 'var(--color-text-primary)' }}
            >
              3. Strava 연동 시 수집 항목
            </h3>
            <ul className="list-disc list-inside space-y-1">
              <li>활동 스트림 데이터 (GPS 좌표, 심박수, 파워, 케이던스, 고도)</li>
              <li>활동 메타데이터 (활동명, 날짜, 거리, 시간)</li>
              <li>선수 프로필 (FTP)</li>
            </ul>

            <h3
              className="text-base font-medium mb-2 mt-4"
              style={{ color: 'var(--color-text-primary)' }}
            >
              4. 자동 수집 항목
            </h3>
            <ul className="list-disc list-inside space-y-1">
              <li>서비스 이용 기록, 접속 로그, 접속 IP 정보</li>
            </ul>
          </section>

          {/* 제3조 개인정보 수집 및 이용 목적 */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              제3조 (개인정보의 수집 및 이용 목적)
            </h2>
            <p className="mb-3">회사는 수집한 개인정보를 다음의 목적으로 이용합니다.</p>
            <ul className="list-disc list-inside space-y-2">
              <li>
                <strong>회원 관리:</strong> 회원제 서비스 제공, 개인식별, 가입의사 확인,
                불량회원의 부정이용 방지
              </li>
              <li>
                <strong>서비스 제공:</strong> 실시간 사이클링 대시보드 표시, 그룹 라이딩
                이벤트 운영, 리플레이 기능 제공
              </li>
              <li>
                <strong>데이터 시각화:</strong> F1 스타일 대시보드에서 텔레메트리 데이터 표시,
                차트 및 통계 제공
              </li>
              <li>
                <strong>서비스 개선:</strong> 서비스 이용 분석 및 개선, 신규 기능 개발
              </li>
            </ul>
          </section>

          {/* 제4조 개인정보 보유 및 이용 기간 */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              제4조 (개인정보의 보유 및 이용 기간)
            </h2>
            <p className="mb-3">
              회사는 개인정보 수집 및 이용 목적이 달성된 후에는 해당 정보를 지체 없이
              파기합니다. 단, 다음의 정보에 대해서는 아래의 사유로 명시한 기간 동안 보존합니다.
            </p>

            <div className="overflow-x-auto">
              <table className="w-full border-collapse mt-3" style={{ borderColor: 'var(--color-border)' }}>
                <thead>
                  <tr style={{ backgroundColor: 'var(--color-bg-secondary)' }}>
                    <th className="border px-3 py-2 text-left" style={{ borderColor: 'var(--color-border)', color: 'var(--color-text-primary)' }}>보존 항목</th>
                    <th className="border px-3 py-2 text-left" style={{ borderColor: 'var(--color-border)', color: 'var(--color-text-primary)' }}>보존 기간</th>
                    <th className="border px-3 py-2 text-left" style={{ borderColor: 'var(--color-border)', color: 'var(--color-text-primary)' }}>보존 근거</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border px-3 py-2" style={{ borderColor: 'var(--color-border)' }}>계정 정보</td>
                    <td className="border px-3 py-2" style={{ borderColor: 'var(--color-border)' }}>회원 탈퇴 시까지</td>
                    <td className="border px-3 py-2" style={{ borderColor: 'var(--color-border)' }}>서비스 제공</td>
                  </tr>
                  <tr>
                    <td className="border px-3 py-2" style={{ borderColor: 'var(--color-border)' }}>활동 데이터 및 파일 (텔레메트리, FIT, GPX)</td>
                    <td className="border px-3 py-2" style={{ borderColor: 'var(--color-border)' }}>회원 탈퇴 시 자동 삭제</td>
                    <td className="border px-3 py-2" style={{ borderColor: 'var(--color-border)' }}>리플레이 기능 제공</td>
                  </tr>
                  <tr>
                    <td className="border px-3 py-2" style={{ borderColor: 'var(--color-border)' }}>서비스 이용 로그</td>
                    <td className="border px-3 py-2" style={{ borderColor: 'var(--color-border)' }}>30일</td>
                    <td className="border px-3 py-2" style={{ borderColor: 'var(--color-border)' }}>보안 및 오류 분석</td>
                  </tr>
                  <tr>
                    <td className="border px-3 py-2" style={{ borderColor: 'var(--color-border)' }}>접속 기록</td>
                    <td className="border px-3 py-2" style={{ borderColor: 'var(--color-border)' }}>3개월</td>
                    <td className="border px-3 py-2" style={{ borderColor: 'var(--color-border)' }}>통신비밀보호법</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h3
              className="text-base font-medium mb-2 mt-4"
              style={{ color: 'var(--color-text-primary)' }}
            >
              그룹 라이딩 데이터 처리
            </h3>
            <p className="mb-3">
              다른 이용자와 함께 그룹 라이딩에 참여한 경우, 회원 탈퇴 시 다음과 같이 처리됩니다:
            </p>
            <ul className="list-disc list-inside space-y-2">
              <li>
                <strong>본인이 생성한 이벤트:</strong> 이벤트의 모든 데이터(텔레메트리, 파일 포함)는 보존되며, 소유권이 '탈퇴한 사용자' 계정으로 이전됩니다. 본인의 라이딩 기록도 '탈퇴한 사용자'로 귀속되어 보존됩니다.
              </li>
              <li>
                <strong>다른 사람의 이벤트에 참가한 경우:</strong> 본인의 라이딩 기록은 '탈퇴한 사용자'로 귀속되어 보존됩니다. 다른 참가자의 데이터에는 영향이 없습니다.
              </li>
              <li>
                <strong>좋아요 및 채팅:</strong> 좋아요와 채팅 기록은 '탈퇴한 사용자'로 귀속되어 보존됩니다.
              </li>
            </ul>
            <p className="mt-3">
              이는 그룹 라이딩의 완전한 기록을 보존하면서, 개인 식별 정보를 제거하기 위함입니다. 탈퇴 후에는 본인의 활동 기록이 특정 개인과 연결되지 않습니다.
            </p>
          </section>

          {/* 제5조 개인정보 제3자 제공 */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              제5조 (개인정보의 제3자 제공)
            </h2>
            <p className="mb-3">
              회사는 정보주체의 개인정보를 제3조에서 명시한 범위 내에서만 처리하며,
              정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및
              제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.
            </p>
            <p className="mb-3">
              <strong>서비스 특성상 다음의 경우 다른 이용자에게 정보가 공개됩니다:</strong>
            </p>
            <ul className="list-disc list-inside space-y-1">
              <li>이벤트 참가 시: 같은 이벤트의 다른 라이더에게 실시간 위치 및 텔레메트리 공개</li>
              <li>이벤트 관전 시: 이벤트 링크를 가진 모든 사람에게 대시보드 정보 공개</li>
              <li>리플레이 생성 시: 공개 리플레이의 경우 다른 이용자가 조회 가능</li>
            </ul>
          </section>

          {/* 제6조 개인정보 처리 위탁 */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              제6조 (개인정보 처리의 위탁)
            </h2>
            <p className="mb-3">
              회사는 서비스 제공을 위해 다음과 같이 개인정보 처리 업무를 위탁하고 있습니다.
            </p>

            <div className="overflow-x-auto">
              <table className="w-full border-collapse mt-3" style={{ borderColor: 'var(--color-border)' }}>
                <thead>
                  <tr style={{ backgroundColor: 'var(--color-bg-secondary)' }}>
                    <th className="border px-3 py-2 text-left" style={{ borderColor: 'var(--color-border)', color: 'var(--color-text-primary)' }}>수탁자</th>
                    <th className="border px-3 py-2 text-left" style={{ borderColor: 'var(--color-border)', color: 'var(--color-text-primary)' }}>위탁 업무 내용</th>
                    <th className="border px-3 py-2 text-left" style={{ borderColor: 'var(--color-border)', color: 'var(--color-text-primary)' }}>보유 기간</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border px-3 py-2" style={{ borderColor: 'var(--color-border)' }}>Amazon Web Services, Inc.</td>
                    <td className="border px-3 py-2" style={{ borderColor: 'var(--color-border)' }}>클라우드 서버 운영 및 데이터 저장 (서울 리전)</td>
                    <td className="border px-3 py-2" style={{ borderColor: 'var(--color-border)' }}>회원 탈퇴 시 또는 위탁 계약 종료 시</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* 제7조 개인정보 파기 */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              제7조 (개인정보의 파기 절차 및 방법)
            </h2>
            <p className="mb-3">
              회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게
              되었을 때에는 지체없이 해당 개인정보를 파기합니다.
            </p>

            <h3
              className="text-base font-medium mb-2"
              style={{ color: 'var(--color-text-primary)' }}
            >
              파기 절차
            </h3>
            <p className="mb-3">
              이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져 내부 방침 및
              기타 관련 법령에 따라 일정기간 저장된 후 파기됩니다.
            </p>

            <h3
              className="text-base font-medium mb-2"
              style={{ color: 'var(--color-text-primary)' }}
            >
              파기 방법
            </h3>
            <ul className="list-disc list-inside space-y-1">
              <li>전자적 파일: 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제</li>
              <li>종이 문서: 분쇄기로 분쇄하거나 소각</li>
            </ul>
          </section>

          {/* 제8조 정보주체의 권리 */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              제8조 (정보주체의 권리·의무 및 행사방법)
            </h2>
            <p className="mb-3">
              정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를
              행사할 수 있습니다.
            </p>
            <ul className="list-disc list-inside space-y-2">
              <li>개인정보 열람 요구</li>
              <li>오류 등이 있을 경우 정정 요구</li>
              <li>삭제 요구</li>
              <li>처리정지 요구</li>
            </ul>
            <p className="mt-3">
              위 권리 행사는 회사에 대해 이메일({' '}
              <a
                href="mailto:privacy-pelo1@baselabs.co.kr"
                className="hover:underline"
                style={{ color: 'var(--color-accent-red)' }}
              >
                privacy-pelo1@baselabs.co.kr
              </a>
              )로 연락하시면 지체 없이 조치하겠습니다.
            </p>
          </section>

          {/* 제9조 Strava 연동 */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              제9조 (Strava 연동)
            </h2>
            <p className="mb-3">
              회사는 Strava와 연동하여 이용자의 사이클링 활동을 가져올 수 있습니다.
              Strava 계정을 연동하면 다음과 같이 데이터가 처리됩니다.
            </p>

            <h3
              className="text-base font-medium mb-2"
              style={{ color: 'var(--color-text-primary)' }}
            >
              수집하는 Strava 데이터
            </h3>
            <ul className="list-disc list-inside mb-4 space-y-1">
              <li>활동 스트림 (GPS 좌표, 심박수, 파워, 케이던스, 고도)</li>
              <li>활동 메타데이터 (활동명, 날짜, 거리, 시간)</li>
              <li>선수 프로필 (FTP)</li>
            </ul>

            <h3
              className="text-base font-medium mb-2"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Strava 연동 해제
            </h3>
            <p className="mb-4">
              프로필 설정에서 언제든지 Strava 연동을 해제할 수 있습니다. 연동 해제 시
              Strava 액세스 토큰이 삭제됩니다. 이전에 가져온 활동 데이터는 리플레이
              기능 제공을 위해 보존됩니다. Strava 데이터의 삭제를 원하시면{' '}
              <a
                href="mailto:privacy-pelo1@baselabs.co.kr"
                className="hover:underline"
                style={{ color: 'var(--color-accent-red)' }}
              >
                privacy-pelo1@baselabs.co.kr
              </a>
              로 요청해 주세요.
            </p>

            <p>
              Strava의 데이터 수집에 관한 자세한 내용은{' '}
              <a
                href="https://www.strava.com/legal/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline"
                style={{ color: 'var(--color-accent-red)' }}
              >
                Strava 개인정보 처리방침
              </a>
              을 참조하세요.
            </p>
          </section>

          {/* 제10조 안전성 확보 조치 */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              제10조 (개인정보의 안전성 확보 조치)
            </h2>
            <p className="mb-3">
              회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.
            </p>
            <ul className="list-disc list-inside space-y-1">
              <li>개인정보 취급 직원의 최소화 및 교육</li>
              <li>개인정보에 대한 접근 제한</li>
              <li>개인정보를 안전하게 저장·전송할 수 있는 암호화 기술 적용 (HTTPS/TLS)</li>
              <li>해킹 등에 대비한 보안 시스템 운영</li>
              <li>비밀번호 암호화 저장</li>
            </ul>
          </section>

          {/* 제11조 쿠키 */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              제11조 (쿠키의 사용)
            </h2>
            <p className="mb-3">
              회사는 최소한의 쿠키 및 로컬 스토리지를 사용합니다.
            </p>
            <ul className="list-disc list-inside space-y-1">
              <li><strong>필수 쿠키:</strong> 로그인 유지를 위한 인증 토큰 (로컬 스토리지)</li>
              <li><strong>환경설정:</strong> 언어 설정 및 UI 환경설정 (로컬 스토리지)</li>
            </ul>
            <p className="mt-3">
              회사는 광고 쿠키나 제3자 추적 픽셀을 사용하지 <strong>않습니다</strong>.
            </p>
          </section>

          {/* 제12조 개인정보 보호책임자 */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              제12조 (개인정보 보호책임자)
            </h2>
            <p className="mb-3">
              회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한
              정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를
              지정하고 있습니다.
            </p>
            <div className="pl-4 border-l-2" style={{ borderColor: 'var(--color-border)' }}>
              <p>
                <strong style={{ color: 'var(--color-text-primary)' }}>
                  개인정보 보호책임자
                </strong>
              </p>
              <p>성명: 김지윤</p>
              <p>전화번호: 010-5061-6585</p>
              <p>
                연락처:{' '}
                <a
                  href="mailto:privacy@baselabs.co.kr"
                  className="hover:underline"
                  style={{ color: 'var(--color-accent-red)' }}
                >
                  privacy@baselabs.co.kr
                </a>
              </p>
            </div>
          </section>

          {/* 제13조 권익침해 구제방법 */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              제13조 (권익침해 구제방법)
            </h2>
            <p className="mb-3">
              정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회,
              한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다.
            </p>
            <ul className="list-disc list-inside space-y-2">
              <li>
                개인정보분쟁조정위원회: (국번없이) 1833-6972 (
                <a
                  href="https://www.kopico.go.kr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:underline"
                  style={{ color: 'var(--color-accent-red)' }}
                >
                  www.kopico.go.kr
                </a>
                )
              </li>
              <li>
                개인정보침해신고센터: (국번없이) 118 (
                <a
                  href="https://privacy.kisa.or.kr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:underline"
                  style={{ color: 'var(--color-accent-red)' }}
                >
                  privacy.kisa.or.kr
                </a>
                )
              </li>
              <li>
                대검찰청 사이버수사과: (국번없이) 1301 (
                <a
                  href="https://www.spo.go.kr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:underline"
                  style={{ color: 'var(--color-accent-red)' }}
                >
                  www.spo.go.kr
                </a>
                )
              </li>
              <li>
                경찰청 사이버수사국: (국번없이) 182 (
                <a
                  href="https://ecrm.cyber.go.kr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:underline"
                  style={{ color: 'var(--color-accent-red)' }}
                >
                  ecrm.cyber.go.kr
                </a>
                )
              </li>
            </ul>
          </section>

          {/* 제14조 아동의 개인정보보호 */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              제14조 (아동의 개인정보보호)
            </h2>
            <p>
              회사는 만 14세 미만 아동의 개인정보 보호를 위하여 만 14세 이상의 이용자에
              한하여 회원가입을 허용합니다. 만 14세 미만 아동이 개인정보를 제공한 사실을
              알게 된 경우 해당 정보를 지체 없이 삭제합니다.
            </p>
          </section>

          {/* 제15조 개인정보 처리방침 변경 */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              제15조 (개인정보 처리방침의 변경)
            </h2>
            <p>
              이 개인정보 처리방침은 2025년 12월 7일부터 적용됩니다. 법령 및 방침에 따른
              변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터
              공지사항을 통하여 고지할 것입니다.
            </p>
          </section>
        </div>

        {/* Footer */}
        <div
          className="mt-12 pt-8 border-t text-center text-sm"
          style={{
            borderColor: 'var(--color-border)',
            color: 'var(--color-text-muted)',
          }}
        >
          <div className="flex justify-center gap-4 mb-2">
            <Link
              to="/terms/ko"
              className="hover:underline"
              style={{ color: 'var(--color-text-secondary)' }}
            >
              이용약관
            </Link>
            <span style={{ color: 'var(--color-border)' }}>|</span>
            <Link
              to="/privacy/ko"
              className="hover:underline"
              style={{ color: 'var(--color-text-secondary)' }}
            >
              개인정보 처리방침
            </Link>
            <span style={{ color: 'var(--color-border)' }}>|</span>
            <Link
              to="/contact"
              className="hover:underline"
              style={{ color: 'var(--color-text-secondary)' }}
            >
              문의하기
            </Link>
          </div>
          &copy; 2025{' '}
          <a
            href="https://baselabs.co.kr"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
            style={{ color: 'var(--color-text-secondary)' }}
          >
            BaseLabs Corp.
          </a>{' '}
          All rights reserved.
        </div>
      </div>
    </div>
  );
}
